import Text from 'components/Text/Text';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import React, { useContext } from 'react';
import EditBtn from 'modules/Devices/DeviceFullInfo/components/DeviceFullInfoModal/components/DeviceFullInfoControlPanel/components/EditBtn';
import style from './DeviceFullInfoControlPanel.module.scss';

const DeviceFullInfoControlPanel: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<div className={style.container}>
			<div className={style.heading}>
				<Text
					className={style.headingText}
					translationKey={deviceForFullInfo?.hardwareId || null}
					size="xxl"
					weight="bold"
				/>
				<EditBtn />
			</div>
		</div>
	);
};

export default DeviceFullInfoControlPanel;
